import { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';

/* ═══════════════════════════════════════════
   EDITABLE: Testimonials data
   - Edit name, role, text for each testimonial
═══════════════════════════════════════════ */
const testimonials = [
  {
    name: 'Rajesh Sharma',
    role: 'Business Owner, Dadar',
    text: 'Ashwamedh Financial Services has been rendering excellent and trustworthy services to me for over 15 years. I have no hesitation in recommending them to investors. Customer service is their forte.',
  },
  {
    name: 'Sunita Patil',
    role: 'Retired Teacher, Mumbai',
    text: 'I find Ashwamedh highly professional. Most important is their understanding of client needs and addressing them properly. The staff is very helpful in addressing problems in time. Right advice to suit my requirements.',
  },
  {
    name: 'Amit Kulkarni',
    role: 'IT Professional, Pune',
    text: 'Ashwamedh provided the right solution to my financial needs bearing in mind my objectives and approach towards risk. The personal and attentive attention they provide to clients is unmatched.',
  },
  {
    name: 'Priya Deshmukh',
    role: 'Doctor, Thane',
    text: 'Ashwamedh has helped me realize not only my short-term goals but also secured my future well. I get a good night\'s sleep, knowing that my investments are growing well. I have planned my whole family\'s future with them.',
  },
];

export const TestimonialsSection = () => {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((current - 1 + testimonials.length) % testimonials.length);
  const next = () => setCurrent((current + 1) % testimonials.length);

  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-20 md:py-32 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-14"
        >
          <p className="text-xs tracking-[0.25em] uppercase font-bold text-[#D4AF37] mb-4">
            Our Testimonials
          </p>
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-bold text-[#0A192F]">
            Together, We Made Financial Dreams a Reality
          </h2>
        </motion.div>

        {/* Testimonial Card */}
        <div className="max-w-3xl mx-auto relative">
          <motion.div
            key={current}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4 }}
            className="bg-white rounded-2xl p-8 md:p-12 shadow-lg text-center"
            data-testid="testimonial-card"
          >
            <Quote size={36} className="text-[#D4AF37]/30 mx-auto mb-6" />
            <p className="text-base sm:text-lg text-[#49566B] leading-relaxed italic mb-8 font-['Outfit']">
              "{testimonials[current].text}"
            </p>
            <div>
              <p className="font-['Playfair_Display'] text-lg font-bold text-[#0A192F]">
                {testimonials[current].name}
              </p>
              <p className="text-sm text-[#D4AF37] font-['Outfit']">
                {testimonials[current].role}
              </p>
            </div>
          </motion.div>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <button
              data-testid="testimonial-prev-btn"
              onClick={prev}
              className="w-10 h-10 bg-[#0A192F] rounded-full flex items-center justify-center text-white hover:bg-[#D4AF37] hover:text-[#0A192F] transition-all"
            >
              <ChevronLeft size={18} />
            </button>
            <div className="flex gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  data-testid={`testimonial-dot-${index}`}
                  onClick={() => setCurrent(index)}
                  className={`w-2.5 h-2.5 rounded-full transition-all ${
                    index === current ? 'bg-[#D4AF37] scale-125' : 'bg-[#0A192F]/20'
                  }`}
                />
              ))}
            </div>
            <button
              data-testid="testimonial-next-btn"
              onClick={next}
              className="w-10 h-10 bg-[#0A192F] rounded-full flex items-center justify-center text-white hover:bg-[#D4AF37] hover:text-[#0A192F] transition-all"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
